/* eslint-disable @typescript-eslint/ban-ts-comment */
import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { ErrorTypes } from '@seller-hermes/utils/errorTypes';

export type SchemaConstructor = (yup: typeof Yup, t: TFunction) => any;

export const useGetYupSchema = () => {
  const { t } = useTranslation('yup');
  const getSchema = useCallback(
    (schemaConstructor: SchemaConstructor) => {
      if (!schemaConstructor) return undefined;
      Yup.addMethod(Yup.string, 'integer', function () {
        // @ts-ignore
        return this.matches(/^\d+$/, t('digits-only'));
      });
      try {
        const yupLocale = t('locale', { returnObjects: true });
        if (yupLocale && typeof yupLocale === 'object') {
          Yup.setLocale(yupLocale);
        }
      } catch (e: any) {
        Sentry.captureMessage(ErrorTypes.YUP_LOCALE, {
          level: 'error',
          extra: { error: e },
        });
      }
      return schemaConstructor(Yup, t);
    },
    [t]
  );

  return getSchema;
};

const useYupSchema = <T extends SchemaConstructor>(
  schemaConstructor: T
): ReturnType<T> => {
  const getYupSchema = useGetYupSchema();
  return getYupSchema(schemaConstructor);
};

export default useYupSchema;
